import React from "react";
import {Create} from "react-admin";
import CreateToolbar from "../../common/forms/CustomToolbar";
import AnnouncementForm from "./edit/AnnouncementForm";

export default (props) => (
  <Create {...props}>
    <AnnouncementForm action='create' toolbar={<CreateToolbar redirect='edit'/>}/>
  </Create>
);